/**
 * Random cache bust func
 */
export default () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

// TODO: This is not the best way to cache bust but the BE will sort out this issue soon enough and we will not need to do this.
